import { Link } from 'react-router-dom';
import Banner from '../components/Banner';
import Flyers from '../components/Flyers';
import '../css/home.scss';
// import { Stages as ListeStages } from '../constants/Stages';
import type { IContact } from '../interfaces/IContact';
import type { IStage } from '../interfaces/IStage';
import { useStages } from '../contexts/StageContext';
import Box from "@mui/material/Box";
import HomeAffiche from '../components/HomeAffiche';

interface IStageObj {
  stage: IStage;
  subscribes: IContact[];
}

interface StageContextType {
  list: IStageObj[];
  loading: boolean;
}
const Home = () => {
  const stageContext: StageContextType = useStages();

  return (
    <div id="home">
      <div id="title">
        <h1>Accueil</h1>
      </div>
      {/* <Box className="flex flex-wrap flex-space-between" id="content"
        sx={(theme) => ({
          backgroundColor: theme.palette.mode === "dark"
            ? 'rgba(50,0,50,.6)'
            : 'rgba(255,255,255,.6)',
          color:  theme.palette.mode === "dark"
          ? 'rgba(255,255,255,1)'
          : 'rgba(0,0,0,1)',
        })}
      > */}
      <Box className="flex flex-wrap flex-space-between" id="content">
        <div id="main-content">

          <Banner />

          <h2>Bonjour à toutes et à tous,</h2>

          <h5>Bienvenue sur le site de CREACIRQUE, l'Ecole de Cirque de Namur !</h5>

          <h3>Les spectacles de fin d'année se dérouleront les 30 et 31 mai 2026.</h3>
          <HomeAffiche />

          <p>Voici les informations importantes concernant le week-end de la Fête de Créacirque.</p>
          <p>Horaires des spectacles</p>
          <ul><li>Samedi 30 mai et dimanche 31 mai : début du spectacle à 13h30</li></ul>
          <p>Voici l'ordre de passage des numéros :</p>

          <p>Samedi 30 mai 2026</p>

          <p>
            11h00-12h30 : Cours de pluri samedi<br />
            12h30-13h30 : Accueil des enfants et parents + temps de midi/restauration<br />
            13h30-14h00 : Pluri 1 mercredi 14h-15h<br />
            14h00-14h30 : Pluri samedi 10h-11h30<br />
            14h30-15h00 : Entracte<br />
            15h00-15h30 : Pluri 2 mercredi 15h-16h30<br />
            15h30-16h00 :Pluri 3 mercredi 16h30-18h00
          </p><p>

            Dimanche 31 mai 2026
          </p><p>
            12h00 : Accueil des enfants et parents + temps de midi/restauration<br />
            13h30-13h45 : Trampoline<br />
            14h00-14h30 : Acrobatie 1<br />
            14h30-15h00:  Acrobatie 2<br />
            15h00-15h30 : Entracte<br />
            15h30-15h50 : Cours libre<br />
            15h50-16h10 : Entracte<br />
            16h10-17h20 : Trapèze 1, 2 et adultes
          </p>

          <p>Toutes nos activités se donnent dans la salle 2 de l'Institut Ste-Marie (227, rue de l'Aurore à 5100 Jambes).</p>
          <p>L'envie qui nous anime est le développement des arts du cirque à travers la créativité, le partage, la perfomance et l'esthétisme.</p>
          <p>N'hésitez à aller voir nos photos qui mettent en valeur le travail de nos talentueux élèves.</p>


          {/* <h4>Les cours débutent la semaine du 15 septembre 2025.</h4> */}
          <div>
            <p>
              Nous vous attendons nombreux et nombreuses pour cette nouvelle saison 2025/2026.
            </p>
            <p>
              Au plaisir de vous revoir pour de nouvelles aventures circassiennes!</p>
          </div>

          <Flyers />

          <p>Voici les documents pour l'année 2025-2026 à nous renvoyer complétés :</p>
          <div id="documents">
            <ul>
              <a target="_blank" rel="noopener noreferrer" download href="https://creacirque.be/Documents/Cr%C3%A9acirque%20-%20Droits%20image.pdf">
                <li className="documents__item">Droits à l'image</li>
              </a>
              <a target="_blank" rel="noopener noreferrer" download href="https://creacirque.be/Documents/Cr%C3%A9acirque%20-%20Licences.pdf">
                <li className="documents__item">Licences</li>
              </a>
              <a target="_blank" rel="noopener noreferrer" download href="https://creacirque.be/Documents/Cr%C3%A9acirque%20-%20Informations%20complémentaires.pdf">
                <li className="documents__item">Informations complémentaires</li>
              </a>
            </ul>
          </div>

          {/* background-color: rgba(255,210,10,.4);
    color: rgba(118,27,123,0.9); */}

        </div>
        <div id="right-panel">
          <Box id="address-crea" className="pane"
            sx={(theme) => ({
              backgroundColor: theme.palette.mode === "dark"
                ? 'rgba(50,0,50,.6)'
                : 'rgba(255,210,10,.4)',
              color: theme.palette.mode === "dark"
                ? 'rgba(255,210,30,1)'
                : 'rgba(118,27,123,0.9)',
            })}>
            <p>
              <b>Adresse du siège social de Créacirque</b><br />
              9, rue de Nèvremont<br />
              5070 Fosses-La-Ville<br />
              Belgique
            </p>
            <p>Téléphone : +32 (0)474/05.21.96<br />
              Numéro de compte : BE 95 0682 1788 4558<br />
              Numéro d'entreprise : 0453.351.769<br />
              Email: <a href="mailto:creacirque@gmail.com">creacirque@gmail.com</a></p>
          </Box>
          <Box id="address-salle" className="pane"
            sx={(theme) => ({
              backgroundColor: theme.palette.mode === "dark"
                ? 'rgba(50,0,50,.6)'
                : 'rgba(255,210,10,.4)',
              color: theme.palette.mode === "dark"
                ? 'rgba(255,210,30,1)'
                : 'rgba(118,27,123,1)',
            })}>
            <p>
              <b>Adresse de la salle de Créacirque</b><br />
              Salle 2 de l'Institut Sainte-Marie<br />
              227, rue de l'Aurore<br />
              5100 Jambes<br />
              Belgique
            </p>
          </Box>
          <div id="button-inscription" className="pane">
            <Link to="les-cours" className="button pointer"
            >
              <span className="text">Inscription aux cours</span>
            </Link>
          </div>
          {stageContext.loading ?
            <p>Chargement en cours...</p>
            :
            stageContext.list.length > 0 ?
              stageContext.list.filter(stage => stage.stage.isVisible).map((stage) => {
                return <div key={stage.stage.name}>
                  <div className={`${stage.stage.isCancelled ? 'strikethrough' : ''}`}>
                    <Link className="color-black" to="stages-week-ends">
                      <div id="stage" className="pane highlight">
                        <h3>{stage.stage.shortTitle}</h3>
                        <p>{stage.stage.date}</p>
                        <p>Salle 2 de l'Institut Sainte-Marie</p>
                        <p>227, rue de l'Aurore à 5100 Jambes</p>
                      </div>
                    </Link>
                  </div>
                  {
                    stage.stage.isCancelled ? <p className="cancelled">ANNULÉ</p> : <></>
                  }

                </div>
              }) :
              <div>
                <p>Le système d'inscription est actuellement en panne.</p>
              </div>
          }
          {/* {ListeStages.map((stage) => {
            return <div key={stage.short_title}>
              <div className={`${stage.isCancelled ? 'strikethrough' : ''}`}>
                <Link className="color-black" to="stages-week-ends">
                  <div id="stage" className="pane highlight">
                    <h3>{stage.short_title}</h3>
                    <p>{stage.date}</p>
                    <p>Salle 2 de l'Institut Sainte-Marie</p>
                    <p>227, rue de l'Aurore à 5100 Jambes</p>
                  </div>
                </Link>
              </div>
              {
                stage.isCancelled ? <p className="cancelled">ANNULÉ</p> : <></>
              }

            </div>
          })} */}
        </div>
      </Box>

    </div>

  )
};

export default Home;
